
import React, { Component, PropTypes } from 'react';

export class SaveButton extends Component {

  handleOnClick(e) {
    const { disabled, onSave } = this.props;
    if (!disabled && onSave) {
      onSave(e);
    }
  }

  render() {
    const { id, type, text, disabled, saving, savingText } = this.props;

    if (saving) {
      return (
        <button
          className="btn btn-primary disabled"
          id={id}
          type="button">
          <span className="glyphicon glyphicon-repeat glyphicon-text spin" />
          {savingText || "Saving..."}
        </button>
      )
    }

    return (
      <button
        disabled={!!disabled}
        onClick={e => this.handleOnClick(e)}
        className="btn btn-primary"
        id={id}
        type={type || 'button'}>
        {text || 'Save'}
      </button>
    )
  }
}

SaveButton.propTypes = {
  type: PropTypes.oneOf(['button', 'submit']),
  text: PropTypes.string,
  disabled: PropTypes.bool,
  saving: PropTypes.bool,
  savingText: PropTypes.string,
  onSave: PropTypes.func,
  id: PropTypes.string,
}

export default SaveButton;



// WEBPACK FOOTER //
// src/common/save-button.js